// Inter font family - minimal, readable
export const FONT_FAMILIES = {
  light: 'Inter_300Light',
  regular: 'Inter_400Regular',
  medium: 'Inter_500Medium',
  semibold: 'Inter_600SemiBold',
  bold: 'Inter_700Bold',
} as const;

export type FontFamily = keyof typeof FONT_FAMILIES;
